import React, { useState, useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useCurrentWidth } from 'react-socks';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Subnavigation = _ref => {
  let {
    overview,
    menu,
    menuTitle
  } = _ref;
  const width = useCurrentWidth();
  const breakpoint = 960;
  const {
    0: mobileMenuOpen,
    1: toggleMobileMenu
  } = useState(false);
  const {
    0: mounted,
    1: setMounted
  } = useState(false);
  const toggleMenu = () => toggleMobileMenu(!mobileMenuOpen);
  useEffect(() => {
    setMounted(true);
  }, []);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(S.Nav, {
    breakpoint: breakpoint,
    mounted: mounted
  }, ___EmotionJSX("div", {
    className: "int-mobile-menu"
  }, ___EmotionJSX("button", {
    onClick: toggleMenu
  }, menuTitle, " ", mobileMenuOpen ? ___EmotionJSX(FaChevronUp, null) : ___EmotionJSX(FaChevronDown, null))), ___EmotionJSX(AnimateHeight, {
    height: width > breakpoint || mobileMenuOpen ? 'auto' : 0
  }, ___EmotionJSX("ul", null, overview && ___EmotionJSX("li", null, ___EmotionJSX(Link, {
    activeClassName: 'current',
    style: {
      fontWeight: 'bold'
    },
    to: `${overview.path}`
  }, overview.displayName)), menu.map(item => {
    return ___EmotionJSX("li", {
      key: item.path
    }, ___EmotionJSX(Link, {
      to: item.path,
      activeClassName: 'current'
    }, item.displayName));
  })))));
};
Subnavigation.defaultProps = {
  showOverview: true,
  menuTitle: 'Menu'
};
export default Subnavigation;